











import { defineComponent } from '@vue/composition-api'

import linkDirective from '@/shared/directives/link-directive'

export default defineComponent({
    name: "IconLinkAtom",
    directives: {
        linkDirective
    },
    props: {
        url: {
            type: String,
            default: undefined
        }
    }
})
